module.exports = `${require.publicPath}engineer.2c40f72b.png`;